import { ExperienceLink } from "src/app/models/experience-link";

export class OpenDialog {
  static readonly type = '[Bookclub links] - Open dialog';

  constructor(public title: string, public links: ExperienceLink[], public resourceId?: string) { }
}

export class CloseDialog {
  static readonly type = '[Bookclub links] - Close dialog';
}

export class SendBookClubHistory {
  static readonly type = '[Bookclub links] - Send book club history';

  constructor(
    public recordId: string,
    public link: ExperienceLink,
    public dontShow: boolean) { }
}
